import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRacing = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22.823 24.502",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.75 0.751)",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(14.124 4.965)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Shape 121",
					d: "M330.3,288.352a.25.25,0,0,1,.25.25",
					transform: "translate(-330.046 -288.352)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Shape 122",
					d: "M330.046,288.6a.25.25,0,0,1,.25-.248",
					transform: "translate(-330.046 -288.352)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Shape 123",
					d: "M330.3,288.852a.251.251,0,0,1-.178-.073.248.248,0,0,1-.072-.177",
					transform: "translate(-330.046 -288.352)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Shape 124",
					d: "M330.546,288.6a.249.249,0,0,1-.25.25",
					transform: "translate(-330.046 -288.352)"
				})
			]
		}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			"data-name": "Path 6",
			d: "M326.238,290.659c.042,2.241,3.044,2.79,5.2,2.918a14.364,14.364,0,0,1,4.271,1.056c.931-.8,1.861-1.776,1.4-2.253a8.458,8.458,0,0,1-2.875-3.37c-.888-1.774-1.5-1.5-2.382-2.457s.648-3.166.648-3.166a6,6,0,0,0-3.3,1.015s-5.2-2.117-10.485,3.212l1.607.613s-2.452,1.019-4.4,5.658l1.86-.053s-.222,4.865,2.718,6.719c7.175,4.525,10.938,3.674,12.968,5.836,0,0,.9-3.348-3.8-8.264-2.495-2.607-1.211-5.058-1.211-5.058",
			transform: "translate(-315.922 -283.387)"
		}) })]
	})
});
export { SvgIconRacing as ReactComponent };
